import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  SharedModule,
  FormInputComponent,
  BooleanCustomFieldConfig,
} from "@bb-vendure/admin-ui/core";
import { Observable,startWith,distinctUntilChanged } from "rxjs";

@Component({
  template: `
    <ng-container *ngIf="isFreeGift$ | async; else NotfreeGift">
      <div>Pre order tag is not available for free gift product</div>
    </ng-container>
    <ng-template #NotfreeGift>
      <div [ngStyle]="{ display: 'flex', 'justify-content': 'space-between' }">
        <label> Toggle preorder tag on storefront </label>
        <input
          type="checkbox"
          clrToggle
          name="enabled"
          [formControl]="formControl"
        />
      </div>
    </ng-template>
  `,
  standalone: true,
  imports: [SharedModule],
})
export default class PreorderToggleComponent
  implements FormInputComponent<BooleanCustomFieldConfig>, OnInit
{
  readonly: boolean;
  config: BooleanCustomFieldConfig;
  formControl: FormControl;

  isFreeGift$: Observable<boolean>;

  ngOnInit(): void {

    this.isFreeGift$ = (this.formControl.parent?.controls as any).freeGifts
      .valueChanges.pipe(distinctUntilChanged(),startWith(this.formControl.parent?.value.freeGifts)) as Observable<boolean>;
  }
}
